import { defineComponent as _defineComponent } from 'vue'
import X from '@/components/svg-components/X.vue';
import CalendarIcon from '@/components/svg/calendar-popup-2.svg?inline';
import CalendarProposeIcon from '@/components/svg/calendar-popup-1.svg?inline';
import BCXButton from '@/components/molecules/BCXButton.vue';
import useI18n from '@/mixins/useI18n';
import useMeetingScheduler from '@/components/meeting-scheduler/composables/useMeetingScheduler';
import BCXInfoCollapsible from '@/components/molecules/BCXInfoCollapsible.vue';
import BCXHelpTextTriggerIcon from '@/components/molecules/BCXHelpTextTriggerIcon.vue';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MeetingHeader',
  setup(__props) {

const { t } = useI18n();
const {
  mode, isStandaloneDraft, startDraft, backToCalendar, closeScheduler
} = useMeetingScheduler();

const isHelpOpen = ref<boolean>(false);

function onCreate() {
  startDraft();
}

function onClose() {
  // DRAFT opened from within the open calendar → X behaves like "abort": back to the calendar.
  if (mode.value === 'DRAFT' && !isStandaloneDraft.value) {
    backToCalendar();
    return;
  }
  // Calendar views or a standalone DRAFT → X closes the scheduler.
  closeScheduler();
}

return { __sfc: true,t, mode, isStandaloneDraft, startDraft, backToCalendar, closeScheduler, isHelpOpen, onCreate, onClose, X, CalendarIcon, CalendarProposeIcon, BCXButton, BCXInfoCollapsible, BCXHelpTextTriggerIcon }
}

})